export default __webpack_public_path__ + "static/media/icon-fleches-vs.f48987f0.svg";